export default "__VITE_PUBLIC_ASSET__6999d777__"